import React, { FC } from 'react';
import classNames from 'classnames';
import { EmptyStateIcon } from '@/componentsUI/Icon';

import styles from './styles/index.module.less';

import { useTranslationPlus } from '@/Core/i18n/useTranslationPlus';
export interface EmptyUIProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'title'> {
  //根据swr的各种状态,展示各种状态空组件
  showIcon?: boolean;
  bkground?: string;
  description?: string;
  icon?: React.ReactNode;
}
const EmptyUI: FC<EmptyUIProps> = (props) => {
  const { t } = useTranslationPlus('HomeView');
  const { bkground, className, description, icon, showIcon = true, ...restProps } = props;

  return (
    <div className={classNames('pt-web-empty', className)} {...restProps}>
      {showIcon && (
        <div className="pt-web-empty-icon">
          <div className={styles['emptyIcon']} style={{ background: bkground }}>
            {icon || <EmptyStateIcon style={{ width: '1em', height: '1em' }} />}
          </div>
        </div>
      )}
      <div className="pt-web-empty-description">{t(description)}</div>
    </div>
  );
};

export default EmptyUI;
